import { IoLogoInstagram } from "react-icons/io5";

const NavbarInstagramButton = () => {
  return (
    <a
      href="https://www.instagram.com/mivekani"
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center justify-center w-10 h-10 shrink-0 rounded-full bg-white text-slate-600 shadow-sm border border-slate-100 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-emerald-200 transition"
    >
      <span className="sr-only">Instagram</span>
      <IoLogoInstagram className="w-5 h-5" />
    </a>
  );
};

export default NavbarInstagramButton;
